<template>
<el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <!--底部样式-->
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="list">
              <HeaderBar :title="barTitle">
                <el-form class="search" inline :model="searchForm" ref="searchForm" label-width="100px">
                  <el-form-item prop="title" style="width: 23%">
                    <el-input v-model="searchForm.title" placeholder="请输入公告标题"></el-input>
                  </el-form-item>

                  <el-form-item prop="releaseUnit" style="width: 23%">
                    <el-input v-model="searchForm.releaseUnit" placeholder="请输入发布单位"></el-input>
                  </el-form-item>
                  <el-form-item prop="date" style="width: 35%">
                    <el-date-picker
                      v-model="date"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="发布开始日期"
                      end-placeholder="发布结束日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="onSearch('searchForm')">查询</el-button>
                    <el-button @click="resetForm('searchForm')">重置</el-button>
                  </el-form-item>
                </el-form>
              </HeaderBar>
              <div class="list-card">
                <el-table
                  :data="lists"
                  :row-style="rowStyle"
                  :cell-style="cellStyle"
                  :show-header="true"
                  max-height="380px"
                  @row-click="handleRowClickEvent"
                  v-loading="loading"
                >
                  <el-table-column prop="title" label="公告标题" show-overflow-tooltip align="left">
                  </el-table-column>
                  <el-table-column prop="infoTypeName" label="公告类型" width="180" align="left"> </el-table-column>
                  <el-table-column prop="releaseUnit" label="发布单位" width="220" align="left"> </el-table-column>
                  <el-table-column prop="resource" label="数据来源" width="120" align="left"> </el-table-column>
                  <el-table-column prop="releaseDate" label="发布时间" width="120" align="left"><template slot-scope="scope">{{renderDate(scope.row.releaseDate)}}</template></el-table-column>
                </el-table>
                <el-divider></el-divider>
                <el-pagination
                  :background="true"
                  layout="prev, pager, next"
                  :total="totalElements"
                  :current-page="pageNo"
                  @current-change="handleSizeChangeEvent"
                >
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
  import * as dayjs from 'dayjs';
  import HeaderBar from '@/components/HeaderBar.vue';
  import { prefixedUrlAsset } from '@/utils/constants';
  export default{
    name: 'PublicityList',
    components: { HeaderBar },
    data() {
      return {
        lists: [],
        barTitle: '自行采购公告公示',
        pageNo: 1,
        pageSize: 10,
        totalElements: 0,
        title: '',
        loading: false,
        searchForm: {},
        date: [],
      }
    },
    mounted() {
      this.getPubInfoList();
    },
    methods: {
      cellStyle() {
        return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
      },
      rowStyle() {
        return 'white-space: nowrap;';
      },
      onSearch(formName) {
        this.current = 1;
        this.getPubInfoList();
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.date = [];
      },
      getPubInfoList() {
        console.log(55, this.date)
        const releaseDateStart = this.date.length ? this.date[0] : '';
        const releaseDateEnd = this.date.length ? this.date[1] : '';
        const params = {
          current: this.pageNo,
          rowCount: this.pageSize,
          ...this.searchForm,
          releaseDateStart,
          releaseDateEnd,
        };
        this.loading = true;

        this.axios.post(`${prefixedUrlAsset}/api/pubInfomation/getPubInfoList`, params).then((({ data })=> {
          if (data.code == 200) {
            this.loading = false;
            this.lists = data.data.data;
            this.totalElements = data.data.total;
          }
        }))
      },
      renderDate(val) {
        return dayjs(val).format('YYYY-MM-DD')
      },
      handleSizeChangeEvent(page) {
        this.pageNo = page;
        this.getPubInfoList();
      },
      handleRowClickEvent(row) {
        this.$router.push({ name: 'PublicityDetail', query: {id: row.id} });
      },
    }
  }
</script>
<style lang="scss">
  .list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    padding: 10px 10px 0px 10px;
    margin-bottom: 20px;
    .list-card {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px 10px 10px 10px;
      width: 100%;
      background-color: white;
      border-left: 1px solid #DCDCDC;
      border-right: 1px solid #DCDCDC;
      border-bottom: 1px solid #DCDCDC;
      box-sizing: border-box;
      border-radius: 0 0 15px 15px;
    }
    .el-form-item__content {
      width: 100%;
    }
    .el-range-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #026D31;
    color: #FFF;
  }
</style>
<style scoped>
  .search {
    padding-left: 10px;
    margin-top: 10px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-button:hover {
    background: none;
    border-color: #026D31;
    color: #026D31;
  }
  .el-button:focus {
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
  }
  .el-button--primary, .el-button--primary:hover, .el-button--primary:focus {
    background: #026D31;
    border-color: #026D31;
    color: #fff;
  }
  .el-button--primary:hover {
   font-weight: bolder;
  }

</style>
